var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade","appear":""}},[_c('div',{staticClass:"celebrations"},[_c('object',{attrs:{"data":"assets/images/RippleConfetti.svg","type":"image/svg+xml"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }